<template>
    <a-row>
        <a-col class="index-info" :span="24">
            <div class="head text-center">
                <img src="../../img/head.png" style="margin: auto">
                <a-dropdown class="mt-2 d-block">
                    <p class="ant-dropdown-link" style="width: 100px">
                        供应商
                    </p>
                </a-dropdown>
            </div>

            <div class="pr-5 mr-5 ml-5" style="border-right: 1px solid rgba(255, 255, 255, 0.2)" v-if="isAuth !== '0' && supplierType === '1'  " >
                <p class="size4" >{{supplierName}}</p>
                <p class="size1 mt-3">
                    <span class="mr-3" >{{supplierCode}}</span>
                    <a-tag color="#f50" v-if=" isAuth === '1'"><span> 已认证</span></a-tag>
                    <a-tag color="#f50" style="cursor: pointer;"  @click="onCertification"  v-if="isAuth === '2'"><span>审核中</span></a-tag>
                    <a-tag color="#f50" @click="onCertificate"  v-if=" isAuth === '3'"><span>认证失败</span></a-tag>
                </p>
            </div>

            <div class="pr-5 mr-5 ml-5" style="border-right: 1px solid rgba(255, 255, 255, 0.2)" v-if=" isAuth !== '0' &&  supplierType === '2'" >
                <p class="size4" >{{supplierName}}</p>
                <p class="size1 mt-3">
                    <span class="mr-3" >{{supplierCode}}</span>
                    <a-tag color="#f50" style="cursor: pointer;" v-if=" isAuth === '1'">已认证</a-tag>
                    <a-tag color="#f50" style="cursor: pointer;" @click="onCertification" v-if="isAuth === '2'">审核中</a-tag>
                    <a-tag color="#f50" style="cursor: pointer;" @click="onCertificate" v-if="isAuth === '3'">认证失败</a-tag>
                </p>
            </div>

            <div>
                <p>
                    <span class="size4" >
                        {{userName}} &nbsp;&nbsp;
                       <a-tag style="cursor: pointer;" color="#f50" v-if="isAuth === '0' ">自然人</a-tag>
                    </span>
                </p>
                <p class="mt-3" >
                    <span >{{accountPhone}}&nbsp;&nbsp;</span>
                    <a-tag color="#87d068" v-if="supplierType === '2' && accountType === '1' ">企业管理员</a-tag>
                </p>
            </div>

            <div style="position: absolute;right: 0;text-align: center;display: flex;">
<!--                <a class="color-ash" @click="onLoadSupplierLht(true)" style="cursor: pointer;margin-right: 40px">-->
<!--                    <a-badge :count="supplierLhtCount">-->
<!--                        <a-badge />-->
<!--                        <img src="../../img/zytz.png">-->
<!--                    </a-badge>-->
<!--                    <p class="color-white" >联合体邀请</p>-->
<!--                </a>-->
                <a class="color-ash" @click="onLoadSupplierNotice(true)" style="cursor: pointer;margin-right: 40px">
                    <a-badge :count="supplierNoticeCount">
                        <a-badge />
                        <img src="../../img/zytz.png">
                    </a-badge>
                    <p class="color-white" >平台通知</p>
                </a>
                <a class="color-ash" @click="onSysMessage" style="cursor: pointer;">
                    <a-badge :count="unReadMsgCount">
                        <a-badge />
                        <img src="../../img/icon1.png">
                    </a-badge>
                    <p class="color-white" >系统消息</p>
                </a>
            </div>
        </a-col>
<!--        <Authing :visible="authingVisible" ref="authing" @cancel="authingCancel"></Authing>-->
<!--        <NatureAuthing :visible="natureAuthingVisible" ref="natureAuthing" @cancel="natureAuthingCancel"></NatureAuthing>-->

        <CmtCertificateInfo :visible="certificateVisible" ref="cfv" @cancel="onClose"></CmtCertificateInfo>
        <supplier-notice  ref="messageRef" :visible="messageVisible" @openView="onOpenSupplierView" @cancel="cancelSupplierMessage"></supplier-notice>
        <supplier-notice-view  ref="messageViewRef" :visible="messageViewVisible" @cancel="cancelSupplierMessageView"></supplier-notice-view>
        <supplier-lht-invitation  ref="lhtInvitationRef" :visible="lhtInvitationVisible" @cancel="()=>{onLoadSupplierLht(false),lhtInvitationVisible=false}"></supplier-lht-invitation>
    </a-row>
</template>

<script>
    import CmtCertificateInfo from '../enterprise/CmtCertificateInfo'
    import moment from "moment";
    import SupplierNotice from "./SupplierNotice";
    import SupplierNoticeView from "./SupplierNoticeView";
    import {ACCESS_TOKEN} from "../../store/mutation-types";
    import SupplierLhtInvitation from "./SupplierLhtInvitation";

    export default {
        props:{
            random:String
        },
        created() {
            this.getSupplierInfo()
            this.unReadCount()
            this.$nextTick(()=>{
                    this.onLoadSupplierNotice(false)
                    this.onLoadSupplierLht(false)
            })
        },
        components: {
            moment,
            CmtCertificateInfo,
            SupplierNotice,
            SupplierNoticeView,
            SupplierLhtInvitation
        },
        name: "",
        data() {
            return {
                currentAccount:this.$ls.get(ACCESS_TOKEN)+'SupplierNotice',
                messageVisible:false,
                messageViewVisible:false,
                userName: '',
                supplierName: '',
                accountPhone: '',
                isAuth: '',
                supplierCode: '',
                supplierType: '',
                natureType: '',
                accountType: '',
                result:'',
                unReadMsgCount:0,
                certificateVisible:false,
                supplierNoticeCount:0,
                supplierLhtCount:0,
                lhtInvitationVisible:false
            }
        },
        methods: {
            // doCertificates() {
            //     let that = this
            //     this.$http.get('/api/v1/supplier/enterprise/get_certifications_status.json').then(function (res) {
            //         debugger
            //         if (res.status === '0') {
            //             that.$router.push({path:'/enterprise/SupplierCertification'})
            //         }else if (res.status === '1') {// 审核中
            //             that.authingVisible = true
            //             that.$refs.authing.initInfo()
            //         }else if (res.status === '2') {// 已通过
            //         }else if (res.status === '3') {// 已驳回
            //             that.$router.push({path:'/enterprise/SupplierCertification'})
            //         }
            //     })
            // },
            onSysMessage() {
                this.$router.push({path: '/message/SysMessage'})
            },
            onLoadSupplierLht(isTrue){
                let that =this
                if (isTrue)
                {
                    that.lhtInvitationVisible = true
                    that.$refs.lhtInvitationRef.onLoad()
                }else {
                    this.$http.get('/api/v1/supplier/lht/getListBySupplierId.json').then(function (res) {
                        if (res.code === 200)
                        {
                            const result = res.result
                            if (result) {
                                that.supplierLhtCount = res.result.length || 0
                            }
                        }
                    })
                }
            },
            onLoadSupplierNotice(isTrue){
                let that = this
                this.$http.get('/api/v1/supplier/notice/getBidNoticeList.json').then(function (res) {
                    if (res.code === 200)
                    {
                        const result = res.result
                       if (result) {
                           that.supplierNoticeCount = result.length
                           if ((localStorage.hasOwnProperty(that.currentAccount) && result.length>0) || isTrue) {
                               if (result.length === 1) {
                                   that.onOpenSupplierView(result[0].id)
                               } else {
                                   that.onSysSupplierMessage()
                               }
                               localStorage.removeItem(that.currentAccount)
                           }
                       }
                    }

                });
            },
            cancelSupplierMessage(item){
                this.messageVisible = false
                if (item)
                {
                    this.$emit('openProjectDetails',item)
                }
            },
            cancelSupplierMessageView(item){
                this.messageViewVisible = false
                if (item)
                {
                    this.$emit('openProjectDetails',item)
                }
            },
            onSysSupplierMessage(item){
                this.$refs.messageRef.onLoad(item)
                this.messageVisible = true
            },
            onOpenSupplierView(id,item){
                this.$refs.messageViewRef.onLoad(id,item)
                this.messageViewVisible = true
            },
            // doNatureAuth() {
            //     let that = this
            //     this.$http.get('/api/v1/supplier/enterprise/get_certifications_status.json').then(function (res) {
            //         debugger
            //         if (res.status === '0') {// 未认证过
            //             that.$router.push({path:'/enterprise/SupplierCertification'})
            //         }else if (res.status === '1') {// 审核中
            //              that.natureAuthingVisible = true
            //             that.$refs.natureAuthing.initInfo()
            //         }else if (res.status === '2') {// 已通过
            //             console.log('has success');
            //         }else if (res.status === '3') {// 已驳回
            //             that.$router.push({path:'/enterprise/SupplierCertification'})
            //         }
            //     })
            // },
            onClose() {
             this.certificateVisible = false
            },
            onCertification() {
                this.certificateVisible = true
            },
            onCertificate() {
                this.$router.push({path:'/enterprise/CertificationIndex'})
            },
            getSupplierInfo() {
                let that = this
                this.$http.get('/api/v1/supplier/info.json').then(function (res) {
                    if (res.code === 200){
                        that.result = res.result
                        that.userName = that.result.nickname
                        that.supplierName = that.result.supplierName
                        that.supplierCode = that.result.supplierCode
                        that.isAuth = that.result.isAuth
                        that.accountPhone = that.result.phone
                        that.supplierType = that.result.supplierType
                        that.natureType = that.result.natureType
                        that.accountType = that.result.accountType
                        that.supplierType = that.result.supplierType
                    }
                });
            },
            unReadCount() {
                let that = this
                this.$http.get('/api/1/supplier/sysMessage/unReadCount.json').then(function (res) {
                    if (res.code === 200) {
                        that.unReadMsgCount = res.result
                    }
                });
            }
        }
    }
</script>
<style lang="less" scoped>
    /deep/ .ant-badge-count{
        box-shadow: 0 0 0 0 #fff;
    }
    .main-nav a{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        background: rgba(255, 255, 255, 0.3);
        margin-right: 2px;
        height: 76px;
    }
    .main-nav a b{
        color: #fff;
        font-weight: 500;
        margin-left: 10px;
    }
    .main-nav a .icon:nth-child(1){
        display: none;
    }
    .main-nav .active{
        background: #f9f9f9;
    }
    .main-nav .active .icon:nth-child(1){
        display: block;
    }
    .main-nav .active .icon:nth-child(2){
        display:none;
    }
    .main-nav .active b{
        color: inherit;
    }
    .main-nav a:hover{
        background: #f9f9f9;
    }
    .main-nav a:hover b{
        color: inherit;
    }
    .main-nav a:hover .icon:nth-child(1){
        display: block;
    }
    .main-nav a:hover .icon:nth-child(2){
        display:none;
    }
    .icon {
        width: 36px;
        height: 36px;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
        line-height: 30px;
        display: block;
    }

    .index-bg {
        position: relative;
        width: 1920px;
        left: 50%;
        margin-left: -960px;
    }

    .index-info {
        display: flex;
        align-items: center;
        color: #fff;
    }

    .index-info img {
        display: block;
    }

    .index-info p {
        margin: 0;
    }

    .shadow {
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);
        border-radius: 6px;
    }

    .shadow:hover {
        background: #f1f9ff;
    }

    /deep/ .ant-tabs-nav .ant-tabs-tab {
        font-size: 20px;
        font-weight: bold;
    }

    /deep/ .ant-tabs-ink-bar {
        bottom: 1px;
        height: 3px;
    }

    /deep/ .ant-list-item-action li {
        padding: 0 30px;
        display: flex;
        align-items: center;
        cursor: auto;
        min-height: 74px;
    }

    /deep/ .ant-list-item-action-split {
        margin-top: 0;
        height: 100%;
        top: 0;
    }

    /deep/ .ant-list-item-action {
        display: flex;
    }

    /deep/ .ant-list-item-meta-title > a {
        font-size: 20px;
    }

    /deep/ .ant-list-item-extra-wrap {
        width: 100%;
        min-height: 74px;
    }

    /deep/ .ant-list-item-extra {
        margin-top: -30px;
        margin-bottom: 0;
    }

    /deep/ .ant-list-item-extra span {
        margin-right: 40px;
    }

    /deep/ .ant-list-item-meta-title {
        margin-top: 8px;
        color: #262626;
        font-weight: bold;
    }

    /deep/ .ant-list-item-meta-title a:hover {
        color: rgb(24, 144, 255) !important;
    }

    /deep/ .ant-list-item {
        position: relative;
        padding: 20px 0 20px 20px;
        background: #fff;
    }

    /deep/ .ant-tabs-bar {
        margin-bottom: 0;
        border-bottom: 3px solid #e6e6e6;
    }
</style>
